import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/base/services/base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AtualizacoesDemandasMfAudit } from '../models/atualizacoes-demandas-mf-audit';

@Injectable({
  providedIn: 'root'
})
export class AtualizacoesDemandasMfAuditService extends BaseService<AtualizacoesDemandasMfAudit> {

  constructor(public http: HttpClient) {
    super(http);
  }

  public getPathModule(): string {
    return '/projetos/demandas-monitoramento';
  }

  public getAtualizacoes(obj: Object = null): Observable<AtualizacoesDemandasMfAudit[]> {
    return this.http.post<AtualizacoesDemandasMfAudit[]>(this.baseUrl + '/atualizacoes', obj, { headers: this.headers });
  }

}